import React from 'react'
import { FaDatabase } from 'react-icons/fa'
import { Form } from 'react-bootstrap'
import { BaseStepCard, StepHeader, StepContent } from './StepCard'
import { gradients } from '../styles'
import SelectedTrainingSourceCard from '../../../SelectedTrainingSourceCard'
import SelectedValidationSourceCard from '../../../SelectedValidationSourceCard'
import DatasetSplitSlider from '../../../DatasetSplitSlider'
import { Model } from '../../../../types/models/model'
import { SelectedTagsCard } from './SelectedTagsCard'
import { useAppSelector, useAppDispatch } from '../../../../store/hooks'
import {
  selectSelectedTrainingSource,
  selectSelectedValidationSource,
  setTrainingSource,
  setValidationSource,
} from '../../../../store/slices/datasetSlice'

interface DatasetSourcesCardProps {
  model: Model | undefined
  trainSplit: number
  shouldSplit: boolean
  onSplitChange: (value: number) => void
  onSplitChangeComplete: () => void
  selectedTagIds: string[]
  onTagSelectionChange: (tagIds: string[]) => void
}

export const DatasetSourcesCard: React.FC<DatasetSourcesCardProps> = ({
  model,
  trainSplit,
  shouldSplit,
  onSplitChange,
  onSplitChangeComplete,
  selectedTagIds,
  onTagSelectionChange,
}) => {
  const dispatch = useAppDispatch()
  const selectedTrainingSources = useAppSelector(selectSelectedTrainingSource)
  const selectedValidationSources = useAppSelector(selectSelectedValidationSource)

  const handleTrainingSourcesChange = (sources: string[]) => {
    dispatch(setTrainingSource(sources))
  }

  const handleValidationSourcesChange = (sources: string[]) => {
    dispatch(setValidationSource(sources))
  }

  return (
    <BaseStepCard>
      <StepHeader $gradient={gradients.sources}>
        Dataset Sources
        <FaDatabase />
      </StepHeader>
      <StepContent>
        <div className="mb-3">
          <SelectedTrainingSourceCard
            selectedSources={selectedTrainingSources || []}
            onSourcesChange={handleTrainingSourcesChange}
            readOnly={model?.state.toLowerCase() === 'training'}
          />
        </div>
        <div>
          <SelectedValidationSourceCard
            selectedSources={selectedValidationSources || []}
            onSourcesChange={handleValidationSourcesChange}
            readOnly={model?.state.toLowerCase() === 'training'}
          />
        </div>
        {shouldSplit && (
          <div className="mt-2 mb-5">
            <h6
              style={{
                fontSize: '1em',
                fontWeight: 'bold',
                color: 'rgba(255, 255, 255, 0.9)',
              }}
            >
              % of Training Source to use for validation
            </h6>
            <Form.Group style={{ padding: '10px 20px', fontSize: '1.05em' }}>
              <DatasetSplitSlider
                value={trainSplit}
                onChange={onSplitChange}
                onChangeComplete={onSplitChangeComplete}
                disabled={model?.state.toLowerCase() === 'training'}
              />
            </Form.Group>
          </div>
        )}
        <div className="mt-3">
          <SelectedTagsCard
            selectedTagIds={selectedTagIds}
            onTagSelectionChange={onTagSelectionChange}
            disabled={model?.state.toLowerCase() === 'training'}
          />
        </div>
      </StepContent>
    </BaseStepCard>
  )
}
